import type { CSSProperties } from 'react';

// 2026-10-26 오너 — "#2103이 스페어용. 콘솔에 표시해두자". 계약 대수와 별도로 매장에 둔 예비 로봇의 배치.
// 고객사 로봇 표 · 로봇 출고 이력이 같은 모양을 쓴다.
export function SpareBadge({ testId }: { testId?: string }) {
  return (
    <span
      data-testid={testId}
      style={badge}
      title="계약 대수와 따로 둔 예비 로봇입니다. 설치 대수에는 넣지 않습니다."
    >
      스페어
    </span>
  );
}

const badge: CSSProperties = {
  display: 'inline-block',
  marginLeft: 6,
  padding: '0 7px',
  borderRadius: 'var(--r-pill)',
  fontSize: 11,
  fontWeight: 700,
  lineHeight: '18px',
  verticalAlign: 'middle',
  border: '1px solid var(--border-default)',
  background: 'var(--bg-warning-subtle)',
  color: 'var(--fg-on-warning-tint)',
  fontFamily: 'var(--font-sans, inherit)',
};
